import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
import Trigger from '@cloud-sn/v-trigger';
import { isArray, warning } from '@cloud-sn/v-utils';
import commonMixin from './mixins/common';
import Menu from './menu.js';
import { getRootSubMenu, getPopupPlacement, isTopSubMenu, getTitle } from './utils';
var __vue_script__ = {
  name: 'SubMenu',
  isSubMenuType: true,
  mixins: [commonMixin],
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      timerFn: null
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-submenu");
    },
    rootSubMenu: function rootSubMenu() {
      return getRootSubMenu(this);
    },
    isSelected: function isSelected() {
      var eventName = this.eventName,
          ancestorSubMenuNames = this.ancestorSubMenuNames;

      if (ancestorSubMenuNames.length === 0) {
        return false;
      }

      return ancestorSubMenuNames.indexOf(eventName) > -1;
    },
    isOpen: function isOpen() {
      var openedSubMenuEventNames = this.openedSubMenuEventNames,
          eventName = this.eventName;
      return openedSubMenuEventNames.indexOf(eventName) > -1;
    },
    isActive: function isActive() {
      var disabled = this.disabled,
          activeItemEventName = this.activeItemEventName,
          eventName = this.eventName;
      return !disabled && activeItemEventName === eventName;
    },
    mode: function mode() {
      var rootMode = this.rootMode,
          level = this.level;

      if (level <= 1) {
        return rootMode;
      }

      return rootMode === 'horizontal' ? 'vertical' : rootMode;
    },
    subMenuMode: function subMenuMode() {
      var rootMode = this.rootMode;
      return rootMode === 'horizontal' ? 'vertical' : rootMode;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          mode = this.mode,
          isActive = this.isActive,
          isSelected = this.isSelected,
          isOpen = this.isOpen;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(mode), true), _defineProperty(_ref, "".concat(prefixCls, "-active"), isActive), _defineProperty(_ref, "".concat(prefixCls, "-selected"), isSelected), _defineProperty(_ref, "".concat(prefixCls, "-open"), isOpen), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    },
    titleClasses: function titleClasses() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-title"), true);
    },
    subClasses: function subClasses() {
      var rootPrefixCls = this.rootPrefixCls;
      return _defineProperty({}, "".concat(rootPrefixCls, "-sub"), true);
    },
    actions: function actions() {
      var disabled = this.disabled,
          trigger = this.trigger;

      if (disabled) {
        return [];
      }

      return isArray(trigger) ? trigger : [trigger];
    },
    popupPlacement: function popupPlacement() {
      return getPopupPlacement(this.mode);
    }
  },
  created: function created() {
    this.rootMenu.addDescendants(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.rootMenu.removeDescendants(this);
  },
  methods: {
    onSubMenuClick: function onSubMenuClick(e) {
      this.rootMenu.onSubMenuClick(e);
    },
    tirggerOpenChange: function tirggerOpenChange(open, type) {
      var eventName = this.eventName,
          onSubMenuClick = this.onSubMenuClick;
      onSubMenuClick({
        open: open,
        name: eventName,
        item: this,
        trigger: type
      });
    },
    onClick: function onClick($event) {
      var isInlineMode = this.isInlineMode,
          eventName = this.eventName,
          tirggerOpenChange = this.tirggerOpenChange,
          isOpen = this.isOpen;
      this.$emit('click', {
        name: eventName,
        domEvent: $event
      });

      if (isInlineMode) {
        tirggerOpenChange(!isOpen, 'click');
      }
    },
    onMouseEnter: function onMouseEnter($event) {
      var eventName = this.eventName;
      this.$emit('mouseenter', {
        name: eventName,
        domEvent: $event
      });
    },
    onMouseLeave: function onMouseLeave($event) {
      var eventName = this.eventName;
      this.$emit('mouseleave', {
        name: eventName,
        domEvent: $event
      });
    },
    onMenuActive: function onMenuActive(e) {
      this.rootMenu.onMenuActive(e);
    },
    onTitleMouseEnter: function onTitleMouseEnter() {
      this.onMenuActive({
        item: this,
        hover: true
      });
    },
    onTitleMouseLeave: function onTitleMouseLeave() {
      this.onMenuActive({
        item: this,
        hover: false
      });
    },
    onPopupVisible: function onPopupVisible(visible) {
      this.tirggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
    },
    renderTrigger: function renderTrigger(titleElement, menuElement) {
      var _this = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isOpen = this.isOpen,
          isDropdownMenu = this.isDropdownMenu,
          actions = this.actions,
          getPopupContainer = this.getPopupContainer,
          popupClass = this.popupClass,
          builtinPlacements = this.builtinPlacements,
          popupPlacement = this.popupPlacement,
          subMenuCloseDelay = this.subMenuCloseDelay,
          subMenuOpenDelay = this.subMenuOpenDelay,
          onPopupVisible = this.onPopupVisible;
      var getContainer = isTopSubMenu(this) && !isDropdownMenu ? getPopupContainer : function () {
        return _this.$el;
      };
      var props = {
        prefixCls: prefixCls,
        popupClass: ["".concat(prefixCls, "-popup"), popupClass],
        initPopupFirst: true,
        visible: isOpen,
        actions: actions,
        getPopupContainer: getContainer,
        builtinPlacements: builtinPlacements,
        popupPlacement: popupPlacement,
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay
      };
      return h(Trigger, {
        "props": _objectSpread({}, props),
        "on": _objectSpread({}, {
          'popup-visible-change': onPopupVisible
        })
      }, [titleElement, menuElement]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var rootPrefixCls = this.rootPrefixCls,
        _this$$slots = this.$slots,
        slotDefault = _this$$slots.default,
        slotTitle = _this$$slots.title,
        title = this.title,
        theme = this.theme,
        classes = this.classes,
        isInlineMode = this.isInlineMode,
        disabled = this.disabled,
        onClick = this.onClick,
        onTitleMouseEnter = this.onTitleMouseEnter,
        onTitleMouseLeave = this.onTitleMouseLeave,
        onMouseEnter = this.onMouseEnter,
        onMouseLeave = this.onMouseLeave,
        titleClasses = this.titleClasses,
        paddingStyle = this.paddingStyle,
        subClasses = this.subClasses,
        isOpen = this.isOpen,
        subMenuMode = this.subMenuMode,
        renderTrigger = this.renderTrigger,
        hasTitleAttr = this.hasTitleAttr;
    var attrs = {
      class: classes
    };

    if (!disabled && !isInlineMode) {
      attrs.on = {
        mouseenter: function mouseenter(e) {
          e.stopPropagation();
          onMouseEnter();
        },
        mouseleave: function mouseleave(e) {
          e.stopPropagation();
          onMouseLeave();
        }
      };
    }

    if (!slotTitle && !title) {
      if (process.env.NODE_ENV !== 'production') {
        warning(false, 'SubMenu需要一个标题');
      }
    }

    var titleAttrs = {
      class: titleClasses,
      style: [paddingStyle],
      attrs: {
        title: hasTitleAttr ? getTitle(slotTitle, title) : ''
      }
    };

    if (!disabled && isInlineMode) {
      titleAttrs.on = {
        click: function click(e) {
          // e.stopPropagation();
          onClick(e);
        },
        mouseenter: onTitleMouseEnter,
        mouseleave: onTitleMouseLeave
      };
    }

    var menuAttrs = {
      class: subClasses,
      props: {
        prefixCls: rootPrefixCls,
        isRoot: false,
        visible: isInlineMode ? isOpen : true,
        mode: subMenuMode,
        theme: theme
      }
    };

    if (!isInlineMode) {
      titleAttrs.slot = 'trigger';
      menuAttrs.slot = 'popup';
    } // 标题元素


    var titleElement = h("div", _mergeJSXProps([{}, titleAttrs]), [slotTitle || h("span", [title])]); // 子菜单

    var menuElement = h(Menu, _mergeJSXProps2([{}, menuAttrs]), [slotDefault]);
    return h("li", _mergeJSXProps3([{}, attrs]), [isInlineMode ? [titleElement, menuElement] : renderTrigger(titleElement, menuElement)]);
  }
};
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "subMenu.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);